<template>
  <div>
    <section v-if="hidden === false ">
      <ul
        class="overall-menu"
        v-if="showHamBurgerIcon===false || (showHamBurgerIcon===true && changeToMobileScreen === false)"
      >
        <li class="sub-menu-parent" tab-index="0" v-for="(menuItem, i) in menuItems" v-bind:key="i">
          <a v-if="menuItem.componentName == ''" href="#">{{menuItem.name}}</a>

          <router-link v-if="menuItem.componentName == 'home'" :to="menuItem.componentName"></router-link>
          <router-link
            v-else-if="menuItem.componentName != ''"
            :to="menuItem.componentName"
            tag="a"
          >{{menuItem.name}}</router-link>

          <ul class="sub-menu">
            <li v-for="(menuSubitem, j) in menuItem.childMenus" v-bind:key="j">
              <router-link
                :to="menuSubitem.componentName"
                tag="a"
                class="submenuitem"
              >{{menuSubitem.name}}</router-link>
            </li>
          </ul>
        </li>
      </ul>
      <div class="sub-menu-parent">
        <div
          v-bind:class="{ containerburger: showHamBurgerIcon===true}"
          v-on:click="showHamBurgerIcon = !showHamBurgerIcon"
        >
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuItems: [
        {
          name: "Create Profile",
          id: "Create Profile",
          componentName: "createprofile",
          childMenus: []
        }
      ],
      showHamBurgerIcon: true,
      changeToMobileScreen: false,
      hidden: false
    };
  },
  methods: {
    isMobileScreeen() {
      setInterval(() => {
        var w = window.innerWidth;
        if (w < 1100) {
          this.changeToMobileScreen = true;
        } else {
          this.changeToMobileScreen = false;
        }
      }, 100);
    },
    isMobileScreeens() {
      setInterval(() => {
        var w = window.innerWidth;
        if (w > 1100) {
          this.hidden = true;
        } else {
          this.hidden = false;
        }
      }, 100);
    }
  },
  mounted() {
    this.isMobileScreeen();
    this.isMobileScreeens();
  },
  computed: {}
};
</script>
<style scoped>
</style>

